import request from '@/utils/request'
import { getToken } from '../utils/auth'

// 查找系统错误日志
export function querysystemerrorlog (params, data) {
  params.token = getToken()
  return request({
    url: '/querysystemerrorlog',
    method: 'post',
    params,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/systemerror.js